import { useEffect, useState } from "react";

export const useSiteContent = () => {
  const [state, setState] = useState({ members: [], events: [], settings: {}, loading: true });

  useEffect(() => {
    const controller = new AbortController();
    Promise.all([
      fetch("/data/members.json", { signal: controller.signal, cache: "no-store" }).then((r) => r.json()),
      fetch("/data/events.json", { signal: controller.signal, cache: "no-store" }).then((r) => r.json()),
      fetch("/data/settings.json", { signal: controller.signal, cache: "no-store" }).then((r) => r.json()),
    ])
      .then(([m, e, s]) =>
        setState({ members: m.members || [], events: e.events || [], settings: s || {}, loading: false })
      )
      .catch((err) => {
        if (err.name !== "AbortError") setState({ members: [], events: [], settings: {}, loading: false });
      });
    return () => controller.abort();
  }, []);

  return state;
};
